import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useRegisterRequests(data = {}) {
  const { enabled = false, configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getList() {
    return privateFetch.get(`/v1/admin/register/user`, configs).then((res) => res.data);
  }

  return useQuery(['register-users-lists', { data }], getList, { enabled, keepPreviousData: true });
}

export default useRegisterRequests;
